"use client";

import { useEffect, useRef, useState } from "react";

export function useScrollEffects() {
  const backgroundRef = useRef<HTMLDivElement | null>(null);
  const [isActionStacked, setIsActionStacked] = useState(false);
  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  // Aurora/grain parallax effect
  useEffect(() => {
    const target = backgroundRef.current;
    if (!target) {
      return;
    }
    let raf = 0;
    const update = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      const auroraY = Math.sin(y / 260) * 8;
      const auroraX = Math.cos(y / 420) * 6;
      const grainY = Math.sin(y / 180) * 2;
      const grainX = Math.cos(y / 300) * 2;
      target.style.setProperty("--aurora-shift-y", `${auroraY}px`);
      target.style.setProperty("--aurora-shift-x", `${auroraX}px`);
      target.style.setProperty("--grain-shift-y", `${grainY}px`);
      target.style.setProperty("--grain-shift-x", `${grainX}px`);
      raf = 0;
    };
    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) {
        window.cancelAnimationFrame(raf);
      }
    };
  }, []);

  // Scroll position tracking
  useEffect(() => {
    const update = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      setIsActionStacked(y > 24);
      setScrolledPastHero(y > window.innerHeight * 0.6);
      setScrollY(y);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => {
      window.removeEventListener("scroll", update);
    };
  }, []);

  return { backgroundRef, isActionStacked, scrolledPastHero, scrollY };
}
